/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $WorkflowStep = {
  properties: {
    id: {
      type: 'WorkflowStepId',
      isRequired: true,
    },
    workflow: {
      type: 'Workflow',
      isRequired: true,
    },
    group: {
      type: 'string',
      isRequired: true,
    },
    order: {
      type: 'number',
      isRequired: true,
    },
    blockedAfter: {
      type: 'WorkflowStepId',
    },
    config: {
      properties: {
        provider: {
          type: 'string',
          isRequired: true,
        },
      },
    },
  },
} as const;
